export type PlannerMode = 'view' | 'edit' | 'all';

export interface TimeIntervalConfig {
    maxDays: number;
    minDays: number;
    interval: number;
}

export const TIME_INTERVAL_CONFIG: TimeIntervalConfig[] = [
    { maxDays: 14, minDays: 11, interval: 8 }, // 8 hours for 11-14 days
    { maxDays: 10, minDays: 8, interval: 6 }, // 6 hours for 8-10 days
    { maxDays: 7, minDays: 4, interval: 4 }, // 4 hours for 4-7 days
    { maxDays: 3, minDays: 2, interval: 2 }, // 2 hours for 2-3 days
    { maxDays: 1, minDays: 1, interval: 1 }, // 1 hour for 1 day
];